import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import './style.css';
import { TextField, MenuItem } from '@material-ui/core';
import PropTypes from 'prop-types';

function Dropdown(props) {
  const {
    listName, error, id, label, name, value, helperText, readOnly, handleChanges,
  } = props;
  const useStyles = makeStyles(() => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      fontFamily: ['Work Sans', 'sans-serif'],
      marginBottom: error ? '0px' : '20px',
    },
  }));

  const classes = useStyles();

  return (
    <TextField
      id={id}
      label={label}
      name={name}
      value={value}
      helperText={helperText}
      error={error === '' ? false : error}
      select
      className={classes.root}
      readOnly={readOnly}
      SelectProps={{
        MenuProps: {
          className: classes.menu,
        },
      }}
      onChange={handleChanges}
      variant="filled"
      {...props}
    >
      {listName.map((option, index) => (
        <MenuItem disabled={readOnly} key={index} value={option.name}>
          {option.name}
        </MenuItem>
      ))}
    </TextField>
  );
}

export default Dropdown;

Dropdown.propTypes = {
  listName: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    }),
  ),
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  readOnly: PropTypes.bool,
  handleChanges: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
};

Dropdown.defaultProps = {
  listName: [{ name: '', value: '' }],
  readOnly: false,
  helperText: '',
  error: false,
  value: false,
};


/* <Dropdown
    name="About"
    label="About"
    id="Enter You Details"
    value={values.learned}
    error={errors.learned}
    helperText={messages.learned}
    handleChanges={(value) => handleInputs('medicalInformation', value.target.value, 'dropdown')}
    listName={learnedFrom}
/> */
